export default __webpack_public_path__ + "static/media/Project-3-JLM-Tourism.02a9fa92.JPG";